import { ContractDuration } from "../ContractDuration";
import { InvalidDateIntervalError } from "../InvalidDateIntervalError";
import { PayPeriodInterval } from "../PayPeriodInterval";
import { WorkOffer } from "../WorkOffer";
import { CzechDocument } from "./CzechDocument";
import { CzechDocumentType } from "./CzechDocumentType";
import { Moment } from "moment-timezone";
import moment from "moment-timezone";

const timezone = "Europe/Prague";

function mom(datetime: string): Moment {
  return moment.tz(datetime, timezone);
}

export class CzechDocumentValidator {
  public static hasVerifiedDocumentOfTypeForPayInterval(verifiedDocuments: Omit<CzechDocument, 'employeeId' | 'employerId'>[], payInterval: PayPeriodInterval, documentType: CzechDocumentType): boolean {
    return verifiedDocuments.some((document) => {
      if (document.type !== documentType) {
        return false;
      }
      return mom(document.startsOn).isSameOrBefore(mom(payInterval.startsOn), 'date')
        && mom(payInterval.startsOn).isSameOrBefore(mom(document.expiresOn), 'date');
    });
  }

  public static daysInIntervals(contractDurations: ContractDuration[]): Moment[] {
    const intervalDays: Moment[] = [];
    const seenDays = new Set<string>();

    for (const {startsOn, endsOn, expiresOn} of contractDurations) {
      const startMoment = mom(startsOn);
      const finishMoment = mom(endsOn ?? expiresOn);

      if (finishMoment.isBefore(startMoment)) {
        throw new InvalidDateIntervalError("Requested interval", startsOn, endsOn ?? expiresOn);
      }

      const start = startMoment.startOf("day");
      const end = finishMoment.endOf("day");

      while (start.isBefore(end)) {
        const dateKey = start.format("YYYY-MM-DD");
        if (!seenDays.has(dateKey)) {
          seenDays.add(dateKey);
          intervalDays.push(start.clone());
        }
        start.add(1, "day");
      }
    }

    return intervalDays;
  }

  public static dayCountThatAnyOfTheseDocumentsIsValidInIntervals(verifiedDocuments: Omit<CzechDocument, 'employeeId' | 'employerId'>[], contractDurations: ContractDuration[], documentTypes: CzechDocumentType[]): number {
    const intervalDays = this.daysInIntervals(contractDurations);

    const verifiedDocumentsOfType = verifiedDocuments.filter((document) => {
      return documentTypes.includes(document.type);
    });

    const daysWithValidDocuments = intervalDays.filter(
      (date) => verifiedDocumentsOfType.some(
        ({ startsOn, expiresOn }) => date.isBetween(mom(startsOn), mom(expiresOn), "date", "[]")
      ));

    return daysWithValidDocuments.length;
  }

  public static hasVerifiedDocumentOfTypeForWorkShift(verifiedDocuments: Omit<CzechDocument, 'employeeId' | 'employerId'>[], workShift: WorkOffer, documentType: CzechDocumentType): boolean {
    return verifiedDocuments.some((document) => {
      if (document.type !== documentType) {
        return false;
      }
      return mom(document.startsOn).isSameOrBefore(mom(workShift.startTime), 'date') && mom(workShift.startTime).isSameOrBefore(mom(document.expiresOn), 'date');
    });

  }
}
